export function createListYear(startYear) {
    var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 2019;  
    while ( startYear <= currentYear ) {
        years.push(startYear++);
    }   
    return years;
}